export default {
  data() {
    return {
      settings: {
        sendLabel: 'add_coupon',
        btnSize: 12,
      },
      groups: {
        coupon: {
          visible: true,
          fields: {
            coupon: {
              type: 'text',
              model: null,
              label: 'insert_coupon',
            },
          },
        },
      },
    };
  },
  methods: {
    init() {
    },
    async callback() {
      this.$store.dispatch('addCoupon', {
        coupon: this.groups.coupon.fields.coupon.model,
      });
    },
  },
};
